import TrpcLibrary from 'digicel-kaizen-library/lib/tripica-library';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { fetchUsageAggregate } from '../../../actions/usage';
import { currentSubscriptionNextRenewalDateSelector } from '../../../modules/Dashboard';
import { isLoadingSelector } from '../../../modules/LoadingStatus';
import DecoratedUsageChart from './DecoratedUsageChart';

const getUsageData = (usages, usageType, history) =>
  history ? TrpcLibrary.getHistoryGraph(usages, usageType) : TrpcLibrary.getUsageGraph(usages, usageType);

const mapStateToProps = (state, ownProps) => {
  const usages = state.usage.summarizedUsages.data;
  const activeUsage = isEmpty(state.usage?.currentUsage) ? usages[0] : state.usage.currentUsage;

  const usagesData = activeUsage
    ? getUsageData(state.usage.usageAggregate, activeUsage.label, state.usage.displayMode === 'monthly')
    : null;
  return {
    data: usagesData,
    max: ownProps.max,
    unitType: ownProps.unitType,
    color: ownProps.color,
    displayMode: state.usage.displayMode,
    nextRenewalDate: currentSubscriptionNextRenewalDateSelector(state),
    isFetching: isLoadingSelector(state, 'fetchUsageAggregate'),
  };
};

const mapDispatchToProps = {
  fetchUsageAggregate,
};

export default connect(mapStateToProps, mapDispatchToProps)(DecoratedUsageChart);
